import React from 'react'
import styles from './Footer.module.scss';

const Footer = () => {
  return (
    <div id = {styles.wrapper_footer}>
      <p>Copyrightⓒ Mujaedal.com All Rights Reserved. If you want to contact us, mail to mujaedal@gmail.com</p>
    </div>
  )
}

export default Footer